export enum Screens {
    sm = 640,
    md = 768,
    lg = 1024,
    xl = 1280,
    xxl = 1536
}

export const appDimensions = {
    appHeaderHeight: 54,
    appHeaderHeightNegative: -54,
}

export const appLanguages = [
    {
        code: 'en',
        culture: 'en-US',
        name: 'English',
        flag: '/assets/images/flags/gb.png'
    },
    {
        code: 'sr',
        culture: 'sr-SR',
        name: 'Crnogorski',
        flag: '/assets/images/flags/me.png'
    },
    {
        code: 'al',
        culture: 'al-SH',
        name: 'Shqip',
        flag: '/assets/images/flags/al.png'
    }
];

export function uuid() {
    function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    return uuidv4();
}

export function switchTheme(toggle: boolean) {
    const htmlElement = document.getElementsByTagName('html')[0];
    
    if (toggle) {
        if (htmlElement.classList.contains('dark')) {
            htmlElement.classList.remove('dark');
        } else {
            htmlElement.classList.add('dark');
        }
    } else {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            htmlElement.classList.add('dark');
        } else {
            htmlElement.classList.remove('dark');
        }
    }
}

export function getScreenSize() {
    const width = window.innerWidth;
    if(width <= Screens.sm) return Screens.sm;
    if(width <= Screens.md) return Screens.md;
    if(width <= Screens.lg) return Screens.lg;
    if(width <= Screens.xl) return Screens.xl;
    if(width <= Screens.xxl) return Screens.xxl;
}

export const AppColors = {
    SUNRISE: '#ff7f2a',
}
